import { AxiosError } from 'axios'
import i18n from 'i18next'
import { is, mapObjIndexed } from 'ramda'
import { toast } from 'react-toastify'

export type ApiErrors = string[] | Record<string, string[] | string>

const showErrorsFromArrayOfStrings = (arrayOfStrings: string[]) =>
  arrayOfStrings.map((e) => toast.error(e))

// Tries to translate the error message, with fallback to original if translation fails
const translateError = (errorMessage: string): string => {
  try {
    const translated = i18n.t(errorMessage)
    // If i18n returns the key (translation failed), try to translate with ID placeholder
    if (translated === errorMessage) {
      // Check if message has a pattern like "#114"
      const idMatch = errorMessage.match(/#(\d+)/)
      if (idMatch) {
        const id = idMatch[1]
        const templateKey = errorMessage.replace(/#\d+/, '{{id}}')
        const templateTranslated = i18n.t(templateKey)
        // If we got a translation, interpolate the ID
        if (templateTranslated !== templateKey) {
          return templateTranslated.replace('{{id}}', `#${id}`)
        }
      }
    }
    return translated
  } catch {
    return errorMessage
  }
}

export const handleApiErrors = (error: AxiosError<ApiErrors, unknown>) => {
  const { response } = error

  if (response && response.status >= 500) {
    toast.error(i18n.t<string>('Internal server error'))
  }

  if (response && response.status >= 400 && response.status <= 499) {
    const { data } = response

    if (is(Array, data) && data.length) {
      showErrorsFromArrayOfStrings(data)
    }

    if (is(Object, data) && !is(Array, data) && data !== null) {
      mapObjIndexed(
        (err) =>
          is(String, err)
            ? toast.error(translateError(err))
            : showErrorsFromArrayOfStrings(err),
        data
      )
    }
  }
}
